// src/utils/themeRegistry.js
import {
  getPolConfig,
  aggregateWeighted,
  buildDemoPredicate,
  baseColorForLikertKey
} from "./polAggregators";
import { resolveJoinKeys } from "./geoJoin";

export const THEMES = {
  pol: {
    getConfig: getPolConfig,                 // { groups, groupOptions, labels, colors }
    aggregate: aggregateWeighted,            // (rows, keys, { rowKey, weight, predicate })
    buildDemoPredicate,
    resolveJoinKeys,                         // decide rowKey/featureKey from geo level + sample row/feature
    weight: "total",
    baseColorForLikertKey,                   // green↔red chooser
    defaultGroupId: "econ_approve",
  },
};
